// extracted by mini-css-extract-plugin
module.exports = {"image":"BrandAvatar__image___2kPuZ","overlay":"BrandAvatar__overlay___3DADS","sm":"BrandAvatar__sm___2aKkW","md":"BrandAvatar__md___2qLQN","shadow":"BrandAvatar__shadow___28aYl"};